<template>
  <header :class="{ active: isActive }">
    <div class="container nav-container">
      <b-navbar
        toggleable="true"
        type
      >
        <b-navbar-toggle target="nav-collapse" />

        <b-navbar-brand href="/">
          <img
            src="../assets/img/logo.svg"
            alt="Ludimos"
          >
        </b-navbar-brand>

        <b-collapse
          id="nav-collapse"
          v-model="showCollapse"
          is-nav
        >
          <button
            class="d-block d-none d-sm-block d-md-none"
            @click="signIn"
          >
            Log in
          </button>
          <hr class="d-block d-none d-sm-block d-md-none">
          <div class="sign-up">
            <b>Sign up</b>
            <a href="https://app.ludimos.com/sign-up">
              Player Account
            </a>
            <!-- <a href="https://app.ludimos.com/register-club">
              Club Account
            </a> -->
            <button @click="openDemoRequest">
              Request coaching account
            </button>
          </div>
          <hr>

          <!-- <router-link to="/pricing">
            Pricing
          </router-link> -->
          <router-link to="/coaches">
            Marketplace
          </router-link>

          <!-- <router-link to="/about">
            Our Team
          </router-link> -->

          <!-- <router-link to="/press">
            News
          </router-link>

          <router-link to="/latest-articles">
            Blog
          </router-link> -->

          <!-- <router-link to="/support">
            FAQ
          </router-link> -->

          <router-link to="/instructions">
            Video guides
          </router-link>

          <router-link to="/contact">
            Contact
          </router-link>
        </b-collapse>
        <button
          v-if="showCTA"
          class="login-button d-sm-none d-md-block d-none"
          @click="signIn"
        >
          Log in
        </button>
        <button
          v-if="showCTA"
          class="start-trail-button secondary-button d-sm-none d-md-block d-none"
          @click="openDemoRequest"
        >
          Request coaching account
        </button>
      </b-navbar>
    </div>
  </header>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      scrollPosition: 0,
      showCollapse: false,
    };
  },
  computed: {
    showCTA() {
      if (
        [
          "coach-profile",
          "coaches",
          "exclusive-coach",
          "hire-coach-form",
          "payment_successful",
          "pricing",
        ].includes(this.$route.name)
      ) {
        return false;
      }
      return true;
    },
    isActive() {
      return this.scrollPosition > 100;
    },
  },
  watch: {
    $route() {
      this.showCollapse = false;
    },
  },
  created() {
    let self = this;
    window.addEventListener("click", function(e) {
      // close dropdown when clicked outside
      // if (self.showCollapse){
      //   self.showCollapse = false;
      // }
      if (!self.$el.contains(e.target)) {
        self.showCollapse = false;
      }
    });
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);
  },
  destroy() {
    window.removeEventListener("scroll", this.updateScroll);
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    signUp() {
      this.$ma.trackEvent({
        fb_event: "Lead",
        category: "Menu",
        action: "Menu",
        label: "Signup",
        type: "Signup",
      });
      window.open(
        `${process.env.VUE_APP_APP_BASE_URL}/sign-up?utm_source=website&utm_medium=Home`
      );
    },
    signIn() {
      this.$ma.trackEvent({
        fb_event: "Login",
        category: "Menu",
        action: "Menu",
        label: "Signin",
        type: "Signin",
      });
      window.open(
        `${process.env.VUE_APP_APP_BASE_URL}/login?utm_source=website&utm_medium=Home`
      );
    },
    openDemoRequest() {
      this.$ma.trackEvent({
        fb_event: "Click",
        category: "Click",
        action: "Request Demo",
        label: "Sticky Header",
        type: "Sticky Header",
      });
      this.$router.push({ name: "request-demo" });
      // window.open(
      //   `${process.env.VUE_APP_APP_BASE_URL}/register-club?utm_source=website&utm_medium=header`
      // );
    },
  },
};
</script>
<style scoped lang="scss">
header {
  height: 60px;
  transition: all 0.3s ease-in-out;
  z-index: 10;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  padding: 20px;
  background: transparent;
  .start-trail-button {
    height: 45px;
  }
  &.active {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    padding: 5px 20px;
    background: rgba(#fff, 0.7);
    &:hover {
      background: rgba(#fff, 0.9);
    }
    .navbar-collapse {
      opacity: 0;
    }
    .start-trail-button {
      border: 2px solid #6f44ff;
      color: #fff;
      background: #6f44ff;
    }
  }
}
.navbar {
  padding: 0;
}

.navbar-collapse {
  transition: all 0.3s ease-in-out;
  background: #2b3060;
  position: absolute;
  top: 50px;
  padding: 0;
  right: 0;
  left: 0;
  border-radius: 4px;
  opacity: 1 !important;
  max-width: 300px;
  max-height: 90vh;
  overflow: auto;
  a,
  button {
    color: #fff;
    border: none;
    background: none;
    display: block;
    margin: 20px;
    font-weight: bold;
    padding: 0;
  }
  hr {
    border-top: 1px solid rgba(#fff, 0.2);
    margin: 20px;
  }
  .sign-up {
    b {
      color: #fff;
      font-weight: bold;
      margin: 20px;
      text-transform: uppercase;
      opacity: 0.5;
      display: block;
    }
    a,
    button {
      margin-left: 40px;
    }
  }
}

.navbar-brand {
  margin-left: 0;
  margin-right: auto;
  img {
    max-width: 140px;
    opacity: 0.5;
    transition: all 0.3s ease-in-out;
  }
  &:hover {
    img {
      opacity: 1;
    }
  }
}
.login-button {
  background: none;
  color: rgba($color: #2b3060, $alpha: 0.7);
  border-radius: 4px;
  padding: 0 15px;
  font-size: 16px;
  height: 45px;
  line-height: 43px;
  font-weight: bold;
  outline: none;
  border: 2px solid transparent;
  transition: all 0.3s ease-in-out;
  margin-left: auto;
  &:hover {
    border: 2px solid #6f44ff;
    color: #fff;
    background: #6f44ff;
  }
}
.start-trail-button {
  min-width: 120px;
  margin-left: 15px;
  transition: all 0.3s ease-in-out;
}
@media (max-width: 767px) {
  .navbar {
    justify-content: flex-start;
  }
  .nav-container {
    padding: 0;
  }
  .navbar-brand {
    margin: 0;
    img {
      max-width: 100px;
    }
  }
  .start-trail-button {
    min-width: 100px;
    margin-left: auto;
    margin-top: 0;
  }

  .login-button {
    color: #fff;
    width: 100%;
    font-size: 14px;
  }
}
</style>
